import React from 'react';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import ScrollContainer from 'react-indiana-drag-scroll';
import './KnowledgeCenterTopicsNav.scss';

class KnowledgeCenterTopicsNavQuery extends Query<Data, {name: String}> {}

const GET_MENU = gql`
    query menuByName($name: String!) {
        menuByName(name: $name) {
            ... on Menu {
                links {
                    ... on MenuLink {
                        label
                        url {
                            routed
                            path
                        }
                    }
                }
            }
        }
    },
`;

const KnowledgeCenterTopicsNav = () => (
    <KnowledgeCenterTopicsNavQuery asyncMode query={GET_MENU} variables={{ name: 'knowledge-center-topics' }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) return null;

            const menu = data.menuByName;

            if (!(menu.links && menu.links.length > 0)) return null;

            return (
                <div id="knowledge-center-topics" className="knowledgeCenterTopicsNav">
                    <div className="container">
                        <ScrollContainer className="knowledgeCenterTopicsNav__list"
                        component="ul">
                            {menu.links.map((link, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <li key={`${index}_${link.label}`} className="knowledgeCenterTopicsNav__item" id={`knowledgeCenterTopicsNav-item-${index}`}>
                                    <a href={link.url.path} className={`knowledgeCenterTopicsNav__itemTarget${link.url.path === (window.location.pathname + window.location.search) ? ' active' : ''}`}>
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ScrollContainer>
                    </div>
                </div>
            );
        }}
    </KnowledgeCenterTopicsNavQuery>
);

export default KnowledgeCenterTopicsNav;



// WEBPACK FOOTER //
// ./frontend/components/KnowledgeCenter/KnowledgeCenterTopicsNav.jsx